/**
 * Wishlist Page Premium - Renderer y Controlador
 * Integración con Cart API de Shopify para añadir productos
 */

document.addEventListener('DOMContentLoaded', async () => {
  // Elementos del DOM
  const overviewView = document.getElementById('wishlist-overview-view');
  const detailView = document.getElementById('wishlist-detail-view');
  const listsContainer = document.getElementById('wishlist-lists-container');
  const productsContainer = document.getElementById('wishlist-products-container');
  const listsGrid = document.getElementById('wishlist-lists-grid');
  const productsGrid = document.getElementById('wishlist-grid');
  const emptyMsg = document.querySelector('.wishlist-empty-msg');
  const loader = document.querySelector('.wishlist-loader');

  // Botones y controles
  const createBtn = document.getElementById('create-wishlist-btn');
  const backBtn = document.getElementById('wishlist-back-btn');
  const renameBtn = document.getElementById('rename-wishlist-btn');
  const deleteBtn = document.getElementById('delete-wishlist-btn');
  const shareBtn = document.getElementById('share-wishlist-btn');
  const addAllBtn = document.getElementById('wishlist-add-all-btn');
  const saveSharedBtn = document.getElementById('save-shared-wishlist');

  // Textos dinámicos
  const currentListName = document.getElementById('wishlist-current-name');
  const itemCountText = document.getElementById('wishlist-item-count');

  // Modales
  const shareMenu = document.getElementById('wishlist-share-menu');
  const deleteModal = document.getElementById('wishlist-delete-modal');
  const deleteConfirmBtn = document.getElementById('wishlist-delete-confirm');
  const deleteCancelBtn = document.getElementById('wishlist-delete-cancel');
  const closeDeleteModal = document.getElementById('close-delete-modal');

  // Helper: Esperar a WishlistManager
  const waitForManager = () => {
    return new Promise(resolve => {
      if (window.WishlistManager) return resolve();
      const interval = setInterval(() => {
        if (window.WishlistManager) {
          clearInterval(interval);
          resolve();
        }
      }, 100);
      setTimeout(() => {
        clearInterval(interval);
        console.warn('WishlistManager timeout');
        resolve();
      }, 5000);
    });
  };

  // Helper: Formatear precio
  const formatMoney = (cents) => {
    if (!cents) return '—';
    return new Intl.NumberFormat('es-ES', {
      style: 'currency',
      currency: 'EUR'
    }).format(cents / 100);
  };

  // Helper: Obtener producto desde API
  const fetchProduct = async (handle) => {
    try {
      const response = await fetch(`/products/${handle}.js`);
      if (!response.ok) return null;
      return await response.json();
    } catch (e) {
      console.error('Error fetching product:', e);
      return null;
    }
  };

  // Renderizar tarjeta de lista
  const renderListCard = (list) => {
    const itemCount = list.items?.length || 0;
    const previewItems = (list.items || []).slice(0, 5);

    let previewHTML = '';
    for (let i = 0; i < 5; i++) {
      if (previewItems[i]?.image) {
        previewHTML += `<div class="wishlist-preview-item"><img src="${previewItems[i].image}" alt="${previewItems[i].title || ''}" loading="lazy"></div>`;
      } else {
        previewHTML += '<div class="wishlist-preview-item"><div class="wishlist-preview-placeholder"></div></div>';
      }
    }

    const translations = window.WishlistTranslations || {};
    const countText = itemCount === 0
      ? (translations.empty_list || 'Lista vacía')
      : itemCount === 1
        ? (translations.one_product || '1 producto')
        : (translations.products_count || '{{ count }} productos').replace('{{ count }}', itemCount);

    return `
      <div class="wishlist-list-card" data-list-id="${list.id}" role="button" tabindex="0">
        <div class="wishlist-list-preview">${previewHTML}</div>
        <div class="wishlist-list-info">
          <div class="wishlist-list-text">
            <h3 class="wishlist-list-name">${list.name || (window.WishlistTranslations?.unnamed_list || 'Lista sin nombre')}</h3>
            <p class="wishlist-list-count">${countText}</p>
          </div>
          <svg class="wishlist-list-arrow" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3" />
          </svg>
        </div>
      </div>
    `;
  };

  // Renderizar tarjeta de producto - Estilo Kave Home Editorial
  // Helper: Generar badges de producto
  const generateProductBadges = (product) => {
    if (!product || !product.tags) return '';
    
    const tags = product.tags || [];
    let badge1 = '';
    let badge2 = '';
    let badgeCount = 0;
    
    // Buscar badges en orden de prioridad
    // 1. Descuentos (-15%, -19%)
    if (badgeCount < 2) {
      if (tags.includes('19%Descuento')) {
        badge1 = '-19% COMPRANDO 2 O MÁS';
        badgeCount = 1;
      } else if (tags.includes('15% descuento o mas')) {
        badge1 = '-15% COMPRANDO 2 O MÁS';
        badgeCount = 1;
      } else if (tags.includes('15%descuento')) {
        badge1 = '-15% COMPRANDO 2';
        badgeCount = 1;
      }
    }
    
    // 2. BEST SELLER
    if (tags.includes('etiqueta_bestseller') && badgeCount < 2) {
      if (badgeCount === 0) {
        badge1 = 'BEST SELLER';
        badgeCount = 1;
      } else {
        badge2 = 'BEST SELLER';
        badgeCount = 2;
      }
    }
    
    // 3. TRENDING
    if (tags.includes('etiqueta_trending') && badgeCount < 2) {
      if (badgeCount === 0) {
        badge1 = 'TRENDING';
        badgeCount = 1;
      } else if (badgeCount === 1 && !badge2) {
        badge2 = 'TRENDING';
        badgeCount = 2;
      }
    }
    
    // 4. ÚLTIMAS UNIDADES
    if (tags.includes('últimas unidades') && badgeCount < 2) {
      if (badgeCount === 0) {
        badge1 = 'ÚLTIMAS UNIDADES';
        badgeCount = 1;
      } else if (badgeCount === 1 && !badge2) {
        badge2 = 'ÚLTIMAS UNIDADES';
        badgeCount = 2;
      }
    }
    
    let badgesHTML = '';
    if (badge1) {
      const badgeClass = badge1.includes('-15%') || badge1.includes('-19%') 
        ? 'card__badge--descuento card__badge--primary' 
        : 'card__badge--primary';
      badgesHTML += `<span class="${badgeClass}">${badge1}</span>`;
    }
    if (badge2) {
      const badgeClass = badge2.includes('-15%') || badge2.includes('-19%') 
        ? 'card__badge--descuento card__badge--secondary' 
        : 'card__badge--secondary';
      badgesHTML += `<span class="${badgeClass}">${badge2}</span>`;
    }
    
    return badgesHTML ? `<div class="product-sigle__tags">${badgesHTML}</div>` : '';
  };

  // Helper: Generar badge de descuento (onsale)
  const generateSaleBadge = (product) => {
    if (!product || !product.variants) return '';
    
    let maxDiscount = 0;
    for (const variant of product.variants) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price && variant.available) {
        const discount = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);
        if (discount > maxDiscount) {
          maxDiscount = discount;
        }
      }
    }
    
    if (maxDiscount > 0) {
      return `<span class="badge onsale">-${maxDiscount}%</span>`;
    }
    return '';
  };

  const renderProductCard = (product) => {
    if (!product) return '';

    const featuredImage = product.featured_image || product.images?.[0] || '';
    const imageUrl = featuredImage ? (typeof featuredImage === 'string' ? featuredImage : featuredImage.src) : '';
    const productUrl = `/products/${product.handle}`;
    const price = formatMoney(product.price);
    const comparePrice = product.compare_at_price ? formatMoney(product.compare_at_price) : null;
    const isOnSale = comparePrice && product.compare_at_price > product.price;

    // Generar badges
    const productBadges = generateProductBadges(product);
    const saleBadge = generateSaleBadge(product);
    const cardBadge = product.tags && product.tags.includes('15%descuento1') 
      ? '<span class="card__badge--15%descuento1">-15% COMPRANDO 2</span>' 
      : '';

    // Precio HTML usando el mismo formato que product-price.liquid
    let priceHTML = '';
    if (isOnSale) {
      priceHTML = `
        <span class="price prod">
          <span class="prods">
            <del><span class="amount">${comparePrice}</span></del>
            <ins><span class="amount">${price}</span></ins>
          </span>
        </span>
      `;
    } else {
      priceHTML = `
        <span class="price prod">
          <ins><span class="amount">${price}</span></ins>
        </span>
      `;
    }

    return `
      <li class="column">
        <product-card class="product-card text-left" data-product-handle="${product.handle}" data-product-id="${product.id}">
          <figure class="product-featured-image">
            <div class="main-product-tags">
              ${productBadges}
            </div>
            ${saleBadge}
            <button type="button" 
                    class="wishlist-btn active"
                    data-product-id="${product.id}"
                    data-product-handle="${product.handle}"
                    aria-label="Eliminar de lista de deseos"
                    title="Eliminar de lista de deseos">
              <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12Z" />
              </svg>
            </button>
            <a href="${productUrl}" 
               class="product-featured-image-link aspect-ratio aspect-ratio--portrait" 
               title="${product.title}"
               rel="nofollow">
              ${imageUrl ? `<img src="${imageUrl}" alt="${product.title}" loading="lazy" class="product-primary-image">` : '<div class="thb-placeholder"></div>'}
            </a>
          </figure>
          ${cardBadge ? `<div class="card-wrapper">${cardBadge}</div>` : ''}
          <div class="product-card-info">
            <a href="${productUrl}" class="product-card-title" title="${product.title}">
              <span class="product-card-title-text">${product.title}</span>
              <span class="coll_p">
                <div class="product-card-title-price">${priceHTML}</div>
              </span>
            </a>
          </div>
        </product-card>
      </li>
    `;
  };

  // Renderizar vista overview
  const renderOverview = async () => {
    if (!window.WishlistManager) return;

    overviewView.style.display = 'block';
    detailView.style.display = 'none';
    listsContainer.style.display = 'block';
    productsContainer.style.display = 'none';

    const lists = window.WishlistManager.getStoredLists();

    if (lists.length === 0 || (lists.length === 1 && lists[0].items.length === 0)) {
      const translations = window.WishlistTranslations || {};
      const emptyText = translations.empty_list 
        ? `${translations.empty_list}. ${translations.create_new_list || 'Crea una nueva para empezar.'}`
        : 'No tienes listas de deseos. Crea una nueva para empezar.';
      listsGrid.innerHTML = `<div class="wishlist-empty-local" style="grid-column: 1 / -1; text-align: center; padding: 60px 20px; color: rgba(var(--color-body-rgb, 21, 21, 21), 0.6);">${emptyText}</div>`;
    } else {
      listsGrid.innerHTML = lists.map(list => renderListCard(list)).join('');
      listsGrid.classList.add('fade-in');
    }
  };

  // Renderizar vista detalle
  const renderDetailView = async (listId) => {
    if (!window.WishlistManager) return;

    const list = window.WishlistManager.getList(listId);
    if (!list) {
      window.history.replaceState({}, '', window.location.pathname);
      return renderOverview();
    }

    overviewView.style.display = 'none';
    detailView.style.display = 'block';
    listsContainer.style.display = 'none';
    productsContainer.style.display = 'block';

    currentListName.textContent = list.name;
    const itemCount = list.items?.length || 0;
    const translations = window.WishlistTranslations || {};
    itemCountText.textContent = itemCount === 0
      ? (translations.empty_list || 'Lista vacía')
      : itemCount === 1
        ? (translations.one_product || '1 producto')
        : (translations.products_count || '{{ count }} productos').replace('{{ count }}', itemCount);

    if (addAllBtn) {
      addAllBtn.dataset.listId = listId;
      addAllBtn.style.display = itemCount > 0 ? 'inline-flex' : 'none';
      addAllBtn.classList.add('wishlist-add-all-btn--primary');
    }

    if (itemCount === 0) {
      emptyMsg.style.display = 'block';
      productsGrid.innerHTML = '';
      loader.style.display = 'none';
    } else {
      emptyMsg.style.display = 'none';
      loader.style.display = 'block';
      productsGrid.innerHTML = '';

      // Cargar productos
      const products = await Promise.all(
        (list.items || []).map(item => fetchProduct(item.handle))
      );

      const validProducts = products.filter(p => p !== null);
      productsGrid.innerHTML = validProducts.map(p => renderProductCard(p)).join('');
      productsGrid.classList.add('fade-in');
      loader.style.display = 'none';
    }
  };

  // Renderizar vista compartida
  const renderSharedView = async (itemsParam) => {
    const handles = itemsParam.split(',').filter(h => h);
    const products = await Promise.all(handles.map(h => fetchProduct(h)));
    const validProducts = products.filter(p => p !== null);

    overviewView.style.display = 'none';
    detailView.style.display = 'block';
    listsContainer.style.display = 'none';
    productsContainer.style.display = 'block';

    const translations = window.WishlistTranslations || {};
    currentListName.textContent = translations.shared_list_title || 'Lista compartida';
    const itemCount = validProducts.length;
    itemCountText.textContent = itemCount === 0
      ? (translations.empty_list || 'Lista vacía')
      : itemCount === 1
        ? (translations.one_product || '1 producto')
        : (translations.products_count || '{{ count }} productos').replace('{{ count }}', itemCount);

    if (addAllBtn) addAllBtn.style.display = 'none';

    productsGrid.innerHTML = validProducts.map(p => renderProductCard(p)).join('');
    productsGrid.classList.add('fade-in');
  };

  // Renderizar según URL
  const renderWishlist = async () => {
    await waitForManager();

    const params = new URLSearchParams(window.location.search);
    const listId = params.get('wishlist-id');
    const sharedItems = params.get('items');

    if (sharedItems) {
      await renderSharedView(sharedItems);
    } else if (listId) {
      await renderDetailView(listId);
    } else {
      await renderOverview();
    }
  };

  // Event Listeners
  if (createBtn) {
    createBtn.addEventListener('click', () => {
      if (window.WishlistManager) {
        window.WishlistManager.openManageModal('create');
      }
    });
  }

  if (backBtn) {
    backBtn.addEventListener('click', () => {
      window.history.pushState({}, '', window.location.pathname);
      renderWishlist();
    });
  }

  if (renameBtn) {
    renameBtn.addEventListener('click', () => {
      const params = new URLSearchParams(window.location.search);
      const listId = params.get('wishlist-id');
      if (listId && window.WishlistManager) {
        window.WishlistManager.openManageModal('rename', listId);
      }
    });
  }

  if (deleteBtn) {
    deleteBtn.addEventListener('click', () => {
      const params = new URLSearchParams(window.location.search);
      const listId = params.get('wishlist-id');
      if (listId && deleteModal) {
        deleteModal.classList.add('active');
        
        // Guardar listId en el modal para usarlo en la confirmación
        deleteModal.dataset.listId = listId;
      }
    });
  }

  // Confirmar eliminación
  if (deleteConfirmBtn) {
    deleteConfirmBtn.addEventListener('click', () => {
      const listId = deleteModal?.dataset.listId;
      if (listId && window.WishlistManager) {
        window.WishlistManager.deleteList(listId);
        deleteModal.classList.remove('active');
        deleteModal.dataset.listId = '';
        window.history.pushState({}, '', window.location.pathname);
        renderWishlist();
      }
    });
  }

  // Cerrar modal de eliminar
  if (deleteCancelBtn) {
    deleteCancelBtn.addEventListener('click', () => {
      if (deleteModal) deleteModal.classList.remove('active');
    });
  }

  if (closeDeleteModal) {
    closeDeleteModal.addEventListener('click', () => {
      if (deleteModal) deleteModal.classList.remove('active');
    });
  }

  // Cerrar modal al hacer clic fuera
  if (deleteModal) {
    deleteModal.addEventListener('click', (e) => {
      if (e.target === deleteModal) {
        deleteModal.classList.remove('active');
      }
    });
  }

  if (shareBtn) {
    shareBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      const isActive = shareMenu.classList.contains('active');
      shareMenu.classList.toggle('active');

      if (!isActive) {
        const params = new URLSearchParams(window.location.search);
        const listId = params.get('wishlist-id');
        if (listId && window.WishlistManager) {
          const list = window.WishlistManager.getList(listId);
          if (list && list.items) {
            const shareUrl = `${window.location.origin}${window.location.pathname}?items=${list.items.map(i => i.handle).join(',')}`;

            const waBtn = document.getElementById('share-whatsapp');
            const fbBtn = document.getElementById('share-facebook');
            const copyBtn = document.getElementById('share-copy-link');

            if (waBtn) waBtn.onclick = () => window.open(`https://wa.me/?text=${encodeURIComponent(shareUrl)}`, '_blank');
            if (fbBtn) fbBtn.onclick = () => window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`, '_blank');
            if (copyBtn) {
              copyBtn.onclick = async () => {
                try {
                  await navigator.clipboard.writeText(shareUrl);
                  if (window.WishlistManager) {
                    window.WishlistManager.showToast('Enlace copiado');
                  }
                } catch (e) {
                  console.error('Error copying:', e);
                }
              };
            }
          }
        }
      }
    });

    // Cerrar al hacer clic fuera
    document.addEventListener('click', (e) => {
      if (!shareBtn.contains(e.target) && !shareMenu.contains(e.target)) {
        shareMenu.classList.remove('active');
      }
    });
  }

  if (addAllBtn) {
    addAllBtn.addEventListener('click', async () => {
      const listId = addAllBtn.dataset.listId;
      if (listId && window.WishlistManager) {
        await window.WishlistManager.addAllToCart(listId);
      }
    });
  }

  // Click en tarjetas de lista
  if (listsGrid) {
    listsGrid.addEventListener('click', (e) => {
      const card = e.target.closest('.wishlist-list-card');
      if (card) {
        const listId = card.dataset.listId;
        window.history.pushState({}, '', `${window.location.pathname}?wishlist-id=${listId}`);
        renderWishlist();
      }
    });

    // Soporte para teclado
    listsGrid.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        const card = e.target.closest('.wishlist-list-card');
        if (card) {
          e.preventDefault();
          card.click();
        }
      }
    });
  }

  // Eliminar producto
  if (productsGrid) {
    productsGrid.addEventListener('click', async (e) => {
      const removeBtn = e.target.closest('.wishlist-remove-btn');
      if (removeBtn) {
        e.preventDefault();
        e.stopPropagation();
        const productId = removeBtn.dataset.productId;
        const params = new URLSearchParams(window.location.search);
        const listId = params.get('wishlist-id');

        if (window.WishlistManager) {
          window.WishlistManager.removeFromWishlist(productId, listId);
          renderWishlist();
        }
      }
    });
  }

  // Popstate para navegación del navegador
  window.addEventListener('popstate', renderWishlist);

  // Listener para actualizaciones de wishlist
  window.addEventListener('wishlist:updated', renderWishlist);

  // Inicializar
  await renderWishlist();
});

